import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";

function NtHospitalityBenefitSection({}) {
  const renderBox = (icon, title, description, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtMaterialIcon name={icon} size={34} color="#006AFF" />
        </View>
        <NtText
          style={{
            color: "white",
            fontSize: 20,
            fontWeight: "600",
            marginTop: 20,
          }}
        >
          {title}
        </NtText>

        <NtText
          style={{
            color: "#8493a8",
            fontSize: 15,
            fontWeight: "500",
            marginTop: 15,
          }}
        >
          {description}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          width: "100%",
        }}
      >
        <NtSectionTitle style={{ textAlign: "left" }}>
          KEY BENEFITS FOR A CONNECTED{"\n"}GUEST EXPERIENCE
        </NtSectionTitle>

        <View style={{ flexDirection: "row", marginTop: 30 }}>
          {renderBox(
            "calendar-month",
            "Organized",
            "Schedule booking, such as spa visitors or conference rooms.",
            {
              marginRight: 10,
              flex: 1,
            }
          )}
          {renderBox(
            "bell",
            "Fast",
            "Call the hotel directory to order food and or drinks from any place with WiFi connectivity on the property.",
            {
              flex: 1,
            }
          )}
        </View>

        <View style={{ flexDirection: "row", marginTop: 10 }}>
          {renderBox(
            "account-group",
            "Easy",
            "Stay connected with hotel staff, friends and family staying on the same property using the app's unlimited calls and messages for the entire stay.",
            {
              marginRight: 10,
              flex: 1,
            }
          )}
          {renderBox(
            "lan-connect",
            "Easy",
            "Stay connected with hotel staff,  friends and family staying on the same property using the app's unlimited calls and messages for the entire stay",
            {
              flex: 1,
            }
          )}
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtHospitalityBenefitSection;
